<script lang="ts" setup>
export interface BoxHeaderProps {
    heading: string;
    subtitle?: string;
    headingLevel: HeadingLevel;
    headingColor?: string;
}

const props = defineProps<BoxHeaderProps>()
const slots = useSlots()
</script>
<template>
  <header class="text-center mb-6 mb-md-12">
    <div
      v-if="slots.tag"
      class="d-flex justify-content-center"
    >
      <slot name="tag" />
    </div>
    <Heading
      :level="props.headingLevel"
      class="mb-3 alfa"
      :class="[props.headingColor, { 'mt-2': slots.tag }]"
    >
      {{ props.heading }}
    </Heading>
    <p
      v-if="props.subtitle"
      class="epsilon fw-normal"
    >
      {{ props.subtitle }}
    </p>
  </header>
</template>
